import React from 'react'
import PropTypes from 'prop-types'
import { useSelector } from 'hooks/redux'
import { PIN, CAN } from 'utils/constants'
import { useMakeDispatchCallback } from 'hooks'
import { setSelectedIdWithDrawer } from 'actions/navigator'
import Condition from 'components/feature/Condition'
import { getFunctionOutputs } from 'selectors/feature/functions'
import LogicGates from '../LogicGates'

import { StyledLogicSetConditions } from './LogicSet.style'

const LogicSet = ({
  conditionIds = [],
  conditions,
  uri,
  finalComplexQueryOperator,
  abComplexQueryOperator,
  cdComplexQueryOperator,
  selectedId,
  fnId,
  isOrphan,
  isEditing,
  showCarry,
}) => {
  const setSelectedIdCallback = useMakeDispatchCallback(setSelectedIdWithDrawer)
  const showAddInput = isEditing && !isOrphan
  // orphans have undefined outputs so default to empty array
  const [output] = useSelector(getFunctionOutputs, { id: fnId }) || []
  const hasOneCondition = Object.keys(conditions).length === 1
  const showLogicSwap =
    isEditing &&
    !isOrphan &&
    showCarry === false &&
    output != null &&
    [PIN, CAN].includes(output.type) &&
    hasOneCondition
  return (
    <>
      <StyledLogicSetConditions>
        {conditionIds.map((conditionUri, index) => {
          // TODO: better names for these?
          const isFirst = index === 0 || index === 2
          const isLast = index === 1 || index === 3
          const isFirstInSet = index === 0
          const isOnly = isFirstInSet && hasOneCondition
          const condition = conditions[conditionUri]
          return (
            <Condition
              key={conditionUri}
              uri={conditionUri}
              conditionIndex={index}
              condition={condition ? { ...condition, isFirstInSet } : null}
              parentQueryUri={uri}
              onClick={() => setSelectedIdCallback(conditionUri)}
              selectedId={selectedId}
              fnId={fnId}
              isFirst={isFirst}
              isFirstInSet={isFirstInSet}
              isLast={isLast}
              isOnly={isOnly}
              isEditing={isEditing}
              showAddInput={showAddInput}
              showLogicSwap={showLogicSwap}
              gates={[
                finalComplexQueryOperator,
                abComplexQueryOperator,
                cdComplexQueryOperator,
              ]}
            />
          )
        })}
      </StyledLogicSetConditions>
      <LogicGates
        finalComplexQueryOperator={finalComplexQueryOperator}
        abComplexQueryOperator={abComplexQueryOperator}
        cdComplexQueryOperator={cdComplexQueryOperator}
        isSelected={uri === selectedId}
        uri={uri}
      />
    </>
  )
}

LogicSet.propTypes = {
  uri: PropTypes.string,
  finalComplexQueryOperator: PropTypes.string,
  abComplexQueryOperator: PropTypes.string,
  cdComplexQueryOperator: PropTypes.string,
  isEditing: PropTypes.bool,
  onCarryFromclick: PropTypes.func,
  affinityGroupNumber: PropTypes.number,
  highlightAffinity: PropTypes.bool,
  onClick: PropTypes.func,
  queryUri: PropTypes.string,
  selectedId: PropTypes.string,
  nodeRef: PropTypes.object,
  fnId: PropTypes.string,
  enterEditor: PropTypes.func,
  scrollToRef: PropTypes.func,
  backToFunctionEditor: PropTypes.func,
  conditionIds: PropTypes.array,
  conditions: PropTypes.object,
  isOrphan: PropTypes.bool,
  showCarry: PropTypes.bool,
}

export default LogicSet
